export default __webpack_public_path__ + "static/media/imprint-data-policy-tablet.c9d5f0e4.jpg";